export const education = (
	<div className=' animate-fadein flex flex-col gap-10 md:w-1/2 w-full'>
		<div className='flex gap-10 justify-between mt-5'>
			<h3 className='text-md font-medium'>SD Negeri Drangong 2</h3>
			<p className='py-1 px-2 rounded-full bg-gray-800 text-white text-sm w-26 h-7 text-center'>
				2009 -2016
			</p>
		</div>
		<div className='flex gap-10 justify-between'>
			<h3 className='text-md font-medium'>SMP Negeri 14 Kota Serang</h3>
			<p className='py-1 px-2 rounded-full bg-gray-800 text-white text-sm w-26 h-7 text-center'>
				2016 - 2019
			</p>
		</div>
		<div className='flex gap-10 justify-between'>
			<div>
				<h3 className='text-md font-medium'>SMK Negeri 5 Kota Serang</h3>
				<h3 className='text-sm font-medium text-gray-600  mt-2'>
					Teknik Komputer Dan jaringan
				</h3>
			</div>
			<p className='py-1 px-2 rounded-full bg-gray-800 text-white text-sm w-26 h-7 text-center'>
				2019 -2022
			</p>
		</div>
	</div>
)

export const skills = (
	<div className='animate-fadein flex flex-col gap-10 md:w-1/2 w-full'>
		<div>
			<h1 class='font-semibold text-lg'>Library & Framework</h1>
			<div className='grid grid-cols-2 gap-5 mt-3 md:text-md text-sm'>
				<div className='font-medium'>
					<li>HTML 5</li>
					<p className='text-gray-600'>Experienced</p>
				</div>
				<div className='font-medium'>
					<li>CSS</li>
					<p className='text-gray-600'>Experienced</p>
				</div>
				<div className='font-medium'>
					<li>JavaScript(ES6)</li>
					<p className='text-gray-600'>Intermediate</p>
				</div>
				<div className='font-medium'>
					<li>React</li>
					<p className='text-gray-600'>Intermediate</p>
				</div>
				<div className='font-medium'>
					<li>TailwindCSS</li>
					<p className='text-gray-600'>Intermediate</p>
				</div>
				<div className='font-medium'>
					<li>BootstrapCSS</li>
					<p className='text-gray-600'>Experienced</p>
				</div>
			</div>
		</div>
		<div>
			<h1 class='font-semibold text-lg'>Tools & Platforms</h1>
			<div className='grid grid-cols-2 gap-5 mt-3 md:text-md text-sm'>
				<div className='font-medium'>
					<li>Git</li>
				</div>
				<div className='font-medium'>
					<li>Github</li>
				</div>
				<div className='font-medium'>
					<li>Netlify</li>
				</div>
				<div className='font-medium'>
					<li>Firebase</li>
				</div>
			</div>
		</div>
	</div>
)

export const project = (
	<div className='animate-fadein flex flex-col gap-10 md:w-1/2'>
		<div>
			<li className='font-semibold text-lg'>React Movie</li>
			<p className='font-normal text-md'>
				Project ini dibuat menggunakan Framework react js, bootstrap, dan sass
				dengan restfull API dari themoviedb.org. terdapat favorit movie, search
				movie, details movie, recomended movie dan tv shows
			</p>
		</div>
		<div>
			<li className='font-semibold text-lg'>Landing Page Company</li>
			<p className='font-normal text-md'>
				Project ini dibuat menggunakan Framework react js, bootstrap, dan sass
				dengan restfull API dari themoviedb.org. terdapat favorit movie, search
				movie, details movie, recomended movie dan tv shows
			</p>
		</div>
		<div>
			<li className='font-semibold text-lg'>Template Dashboard Course App</li>
			<p className='font-normal text-md'>
				Ini adalah sebuah template dashboard yang dibuat menggunakan sebuah
				Library Framework React dan Tailwind. Responsive di berbagai device,
				serta terdapat fitur darkmode
			</p>
		</div>
		<div>
			<li className='font-semibold text-lg'>E-commerce</li>
			<p className='font-normal text-md'>
				Project E-Commerce ini dibuat menggunakan react js dan tailwindCSS
				sebagai stylingnya. Firebase digunakan sebagai penyimpanan terhadap
				produk yang dibuat serta google authentication sebagai Loginnya.
				Menggunakan React Context sebagai state management
			</p>
		</div>
	</div>
)

export const interest = (
	<div className='animate-fadein flex flex-col gap-10 md:w-1/2'>
		<div>
			<li className='text-lg font-semibold'>Movie</li>
			<p>
				Menonton film itu adalah sesuatu yang menyenangkan, apalagi jalan cerita
				yang tidak bisa ditebak. nonton film juga bisa menjadi inspirasi yang
				lewat, ntah meskipun diimplementasikan atau tidak heheh :)
			</p>
		</div>
		<div>
			<li className='text-lg font-semibold'>Traveling</li>
			<p>
				Siapa yang tidak suka dengan hal yang satu ini, semua pasti suka. Begitu
				juga dengan saya, saya lebih suka berlibur ke tempat tempat alam,
				seperti pantai, curug, mendaki gunung, ataupun ke kebun kebun yang
				udaranya masih segar.
			</p>
		</div>
		<div>
			<li className='text-lg font-semibold'>Music</li>
			<p>
				Ada beberapa genre yang saya suka dari musik, seperti pop dan reggae.
				Musik juga bisa menemani saya ketika ngoding atau mendesain yang membuat
				suasana seperti nyaman dan santai
			</p>
		</div>
	</div>
)
